import { TCountry, TEntity, TLanguage, TUserType } from '../types'
import { IGetUserEntitiesResponse } from '../types/app-context/repository'
import { entityPayloadMap } from '../types/app-context/components/utils'

const countryMapper: Record<string, TCountry> = {
  BR: 'BR',
  US: 'US',
  AR: 'AR',
}

const accountTypeMapper: Record<string, TUserType> = {
  PF: 'PF',
  PJ: 'PJ',
  MEI: 'MEI',
  US: 'US',
  AR: 'AR',
}

const languageMapper: Record<string, TLanguage> = {
  'pt-BR': 'pt-BR',
  'en-US': 'en-US',
  'es-ES': 'es-ES',
}

const entityMapper: Record<string, TEntity> = {
  BR: 'BR',
  US_BRANCH: 'US_BRANCH',
}

const parseCountryParam = (value: string): TCountry => {
  const country = countryMapper[value]
  if (!country) throw new Error(`Country ${value} not supported`)
  return country
}

const parseLanguageParam = (value: string): TLanguage => {
  const language = languageMapper[value]
  if (!language) throw new Error(`Language ${value} not supported`)
  return language
}

const parseAccountTypeParam = (value: string): TUserType => {
  const accountType = accountTypeMapper[value]
  if (!accountType) throw new Error(`Account type ${value} not supported`)
  return accountType
}

const parseEntityParam = (value: string): TEntity => {
  const entity = entityMapper[value]
  if (!entity) throw new Error(`Entity ${value} not supported`)
  return entity
}

const makeTypedPathParam = {
  country: parseCountryParam,
  language: parseLanguageParam,
  accountType: parseAccountTypeParam,
  entity: parseEntityParam,
} as const

const isBrazil = (organization: TUserType) =>
  organization === 'PJ' || organization === 'MEI' || organization === 'PF'

const setUserCountry = (organization: TUserType): TCountry =>
  isBrazil(organization) ? 'BR' : organization

interface IEntityOrganizationParams {
  entitiesOrganizations?: IGetUserEntitiesResponse
  entity?: TEntity
}

const getEntityOrganization = ({ entitiesOrganizations, entity }: IEntityOrganizationParams) => {
  if (!entitiesOrganizations || !entity) return undefined

  const entityKey = entityPayloadMap[entity]

  return entitiesOrganizations.accountOrganizations[entityKey]
}

export { makeTypedPathParam, setUserCountry, getEntityOrganization }
